import { useState } from 'react';
import type { ChatMessage } from '@/types/chat';

export const useChatState = () => {
  const [message, setMessage] = useState('');
  const [uploadedFiles, setUploadedFiles] = useState<File[]>([]);
  const [imageDataList, setImageDataList] = useState<string[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [messages, setMessages] = useState<ChatMessage[]>([]);

  const clearState = () => {
    setMessage('');
    setUploadedFiles([]);
    setImageDataList([]);
  };

  const addFile = (file: File, base64Image: string) => {
    setUploadedFiles(prev => [...prev, file]);
    setImageDataList(prev => [...prev, base64Image]);
  };

  const removeFile = (index: number) => {
    setUploadedFiles(prev => prev.filter((_, i) => i !== index));
    setImageDataList(prev => prev.filter((_, i) => i !== index));
  };

  return {
    message,
    setMessage,
    uploadedFiles,
    imageDataList,
    isLoading,
    setIsLoading,
    messages,
    setMessages,
    clearState,
    addFile,
    removeFile
  };
};